import { Box, CircularProgress, Typography } from '@mui/material';
import { passGemsIconSrc } from '../../assets/bazzar';
import PassCard from './PassCard';

const PANEL_BORDER = '1px solid #ff00f2';
const PANEL_BG = 'linear-gradient(93.9deg, rgba(52, 0, 49, 0.8) 0.67%, rgba(28, 0, 67, 0.8) 99.67%)';

/** Figma 11389:6202–6206 — gems promo banner */
function PassesPromoBanner() {
  return (
    <Box
      sx={{
        mx: 'auto',
        width: '100%',
        maxWidth: { xs: '100%', md: 784 },
        minHeight: 68,
        bgcolor: 'rgba(0, 0, 0, 0.2)',
        border: '0.5px solid rgba(255, 0, 242, 0)',
        borderBottomLeftRadius: '16px',
        borderBottomRightRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '14px',
        px: { xs: 2, md: 3 },
        py: { xs: 1.5, md: 0 },
      }}
    >
      <Box
        component="img"
        src={passGemsIconSrc}
        alt=""
        aria-hidden
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          display: 'block',
        }}
      />
      <Typography
        sx={{
          color: '#fff',
          fontWeight: 700,
          fontSize: { xs: 16, md: 20 },
          lineHeight: { xs: '24px', md: '32px' },
          letterSpacing: '0.8px',
          textAlign: 'center',
        }}
      >
        Get unlimited Gems and unlock your game power more
      </Typography>
      <Box
        component="img"
        src={passGemsIconSrc}
        alt=""
        aria-hidden
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          display: { xs: 'none', sm: 'block' },
        }}
      />
    </Box>
  );
}

/** Figma 11389:6181 — passes panel with promo banner and pass cards */
export default function PassesPanel({ cards, loading, onCardClick }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 1296,
        mx: 'auto',
        border: PANEL_BORDER,
        borderRadius: '20px',
        background: PANEL_BG,
        overflow: 'hidden',
      }}
    >
      <PassesPromoBanner />

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: { xs: '25px', md: '35px' },
          justifyContent: 'center',
          alignItems: 'flex-start',
          px: { xs: 2, md: '38px' },
          pt: { xs: 3, md: '38px' },
          pb: { xs: 3, md: '38px' },
        }}
      >
        {loading ? (
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress sx={{ color: '#ff00f2' }} />
          </Box>
        ) : cards.length === 0 ? (
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 6 }}>
            <Typography sx={{ color: '#e6d4ff', fontSize: 14, fontWeight: 600 }}>
              No passes available right now.
            </Typography>
          </Box>
        ) : (
          cards.map((card) => (
            <Box
              key={card.id}
              sx={{
                width: { xs: '100%', sm: 381 },
                maxWidth: 381,
                flexShrink: 0,
              }}
            >
              <PassCard card={card} onClick={onCardClick} />
            </Box>
          ))
        )}
      </Box>
    </Box>
  );
}
